// 資料請求周り
var documentRequested = function(handle) {
  return $.inArray(handle, Shopify.Products.getDocumentRequest()) >=0
}

var addList = function(handle) {
  var handle = String(handle);
  if(documentRequested(handle)) {
    // リストから削除
    Shopify.Products.removeDocumentRequest({}, handle);
    $("#memorial-" + handle + " .js-list-label").html('検討リストに追加');
    $("#memorial-" + handle + " .check").removeClass('checked');
  } else {
    // リストに追加
    Shopify.Products.recordDocumentRequest({}, handle);
    $("#memorial-" + handle + " .js-list-label").html('検討リストに追加済み');
    $("#memorial-" + handle + " .check").addClass('checked');
  }  
  if($(".checked").length > 0) {
    $(".js-add-list-cv").addClass("display");
  } else {
    $(".js-add-list-cv").toggleClass("display");
  }

}

var addListAndRedirect = function(handle) {
  handle = String(handle);
  Shopify.Products.recordDocumentRequest({}, handle);
  location.href="/pages/memorial_request";
}


var initializeList = function() {
  $("[id^=memorial-]").not("[id^=memorial-json]").each(function(index, elem){
    var handle = elem.id.split("memorial-")[1];
    if(documentRequested(handle)) {
      $("#memorial-" + handle + " .js-list-label").html('検討リストに追加済み');
      $("#memorial-" + handle + " .check").addClass('checked');
    } else {
      $("#memorial-" + handle + " .js-list-label").html('検討リストに追加');
      $("#memorial-" + handle + " .check").removeClass('checked');
    }
  });  
}
